import BaseButton from "@/components/Button";
import { forwardRef } from "react";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 5rem;
  padding: 0 1.5rem;
`;

export const Button = forwardRef<HTMLAnchorElement, any>(function Button(
  props,
  ref
) {
  return (
    <BaseButton
      as="a"
      ref={ref}
      variant="primaryBoxed"
      {...props}
      style={{ alignSelf: "end" }}
    />
  );
});
